import React from 'react';

import { SkeletonRoot, SkeletonRow, SkeletonStack } from './styles';

export interface SkeletonProps
  extends Omit<React.HTMLAttributes<HTMLSpanElement>, 'children'> {
  height: number | string;
  width?: number | string;
  radius?: number | string;
  circle?: boolean;
  label?: string;
}

const toCss = (value: number | string): string =>
  typeof value === 'number' ? `${value}px` : value;

const Skeleton = ({
  height,
  width,
  radius = 8,
  circle = false,
  label,
  ...rest
}: SkeletonProps): JSX.Element => (
  <SkeletonRoot
    $height={toCss(height)}
    $width={width !== undefined ? toCss(width) : undefined}
    $radius={circle ? '50%' : toCss(radius)}
    role={label ? 'status' : undefined}
    aria-label={label}
    aria-hidden={label ? undefined : true}
    {...rest}
  />
);

export { SkeletonRow, SkeletonStack };
export default Skeleton;
